import api from "../scripts/_api";
import moment from "moment";

export default {

	data() {
		return {
			client_token: null,
			session_id: null,
			isKlarnaReady: false
		}
	},
	computed: {
		klarnaImage() {
			return this.Reservation.Payment.Method === "Klarna" ? "/icons/klarna.svg" : "/icons/klarna_grey.svg";
		},
	},
	methods: {

		// load script on initialization
		klarnaLoadScript() {
			let externalScript = document.createElement('script')
			externalScript.setAttribute('src', 'https://x.klarnacdn.net/kp/lib/v1/api.js')
			document.head.appendChild(externalScript)
		},

		// klarna auth call
		async klarnaAuthorize(reservation) {
			return new Promise((resolve, reject) => {
				const billing_address = {
					given_name: reservation.ProfileInfos.Shipping.Givenname,
					family_name: reservation.ProfileInfos.Shipping.Lastname,
					email: reservation.ProfileInfos.Shipping.Communication.Email,
					title: reservation.ProfileInfos.Shipping.Title,
					street_address: reservation.ProfileInfos.Shipping.Address.AddressLine1,
					postal_code: reservation.ProfileInfos.Shipping.Address.PostalCode,
					city: reservation.ProfileInfos.Shipping.Address.City,
					phone: reservation.ProfileInfos.Shipping.Communication.Phone,
					country: reservation.ProfileInfos.Shipping.Address.Country.ISOCode || "DE",
				};

				var reviseReservation = (res, authResult) => {
					res._Payment.Klarna = {
						ClientToken: this.client_token,
						AuthorizationToken: authResult.authorization_token
					};
					res._Payment.SessionId = this.session_id;

					return res;
				}

				window.Klarna.Payments.authorize({
						payment_method_category: "pay_now"
					}, {
						billing_address
					},
					function (authRes) {
						// finalize if required
						if (authRes.finalize_required) {

							window.Klarna.Payments.finalize({
									payment_method_category: "pay_now"
								}, {},
								function (finalizeRes) {
									// finalize success
									if (finalizeRes.approved) {
										return resolve(reviseReservation(reservation, finalizeRes))
									}
									// finalize failed
									else return reject("Finalize failed")
								})
						}
						// else return authRes
						else if (authRes.approved) {
							return resolve(reviseReservation(reservation, authRes))
						}
						reject("Authorize failed")
					})
			})
		},

		// initialize klarna payment by createing a session
		klarnaInit(reservation, onSuccess) {
			this.isKlarnaReady = false;
			this.client_token = null;
			this.session_id = null;

			reservation._Payment = {
				...reservation._Payment,
				Provider: "Klarna",
				Method: "Klarna",
				PrePayments: [{
					Value: this.totalSum,
					ValueType: "Absolute",
					Deadline: moment().toISOString()
				}]
			}

			api.post("payment/Entity.Ticketing.Reservation/init", reservation, result => {
				if (result.Meta && result.Meta.IsValid && result.Value && result.Value._Payment) {
					this.client_token = result.Value._Payment.Klarna.ClientToken;
					this.session_id = result.Value._Payment.SessionId;

					if (onSuccess) onSuccess(result.Value);
				}
				this.isKlarnaReady = true;
			});
		},

		// initialize klarna and load widget into dom
		klarna() {
			window.Klarna.Payments.init({
				client_token: this.client_token,
			})
			window.Klarna.Payments.load({
					container: '#klarna-payments-container',
					payment_method_category: 'pay_now',
					preferred_payment_method: 'direct_debit'
				},
				function (res) {
					console.log("klarna load response", res)
				}
			)
		},

		// remove klarna elements from dom
		klarnaDestroy() {
			let container = document.getElementById('klarna-payments-container');
			var child = container.lastElementChild;
			while (child) {
				container.removeChild(child);
				child = container.lastElementChild;
			}
		}
	}
}